export default __webpack_public_path__ + "static/media/new_new_white_boundary_centered.9e96088a.png";